export default function page(component, store) {
	return new component({
		target: document.body,
		props: {
			store
		}
	});
}